"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
const styles_1 = require("../styles");
function AccountAvatarIcon(props) {
    return (react_1.default.createElement(react_native_svg_1.default, Object.assign({ width: 32, height: 32, fill: "none" }, props),
        react_1.default.createElement(react_native_svg_1.Path, { stroke: styles_1.Colors.primary, fill: styles_1.Colors.lightBlue, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12Z" }),
        react_1.default.createElement(react_native_svg_1.Path, { stroke: styles_1.Colors.primary, fill: styles_1.Colors.white, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M16 20a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z" }),
        react_1.default.createElement(react_native_svg_1.Path, { stroke: styles_1.Colors.primary, fill: styles_1.Colors.white, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M7.975 24.925a9 9 0 0 1 16.05 0" })));
}
exports.default = AccountAvatarIcon;
